module.exports = __webpack_public_path__ + "fonts/LTCCaymanGoudyModern-Italic.8c8c821287f8abe3c20c35d5bc0125dd.otf";